import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d59be47&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d59be47')) {
      api.createRecord('0d59be47', component.options)
    } else {
      api.reload('0d59be47', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d59be47&", function () {
      api.rerender('0d59be47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/systemTools/formCreate/index.vue"
export default component.exports